import React, { useEffect, useState } from "react";

const AssessmentFormBody = ({
  mode,
  index,
  formData,
  onChange,
  setFormData,
  selectedProbeIds,
}) => {
  // Safe initialization supporting both single-body (uppercase) and multi-body mapped (lowercase) properties
  const [bodyItems, setBodyItems] = useState(() => {
    if (Array.isArray(formData.Body) && formData.Body.length > 0)
      return formData.Body;
    if (Array.isArray(formData.body) && formData.body.length > 0)
      return formData.body;
    return [{ Word: "", Solution: "", SolutionDetails: "", Scores: "" }];
  });

  const { CategoryID } = formData;

  useEffect(() => {
    // Avoid clearing the main form Title on mount or category changes
    // (it was causing the top Title to disappear when multiple bodies mount).
    if (mode !== "edit") setFormData((prev) => ({ ...prev, Body: "" }));
  }, [CategoryID]);

  // Bubble state updates cleanly up to the parent array structure or update locally
  const handleBodyItemsChange = (updatedItems) => {
    setBodyItems(updatedItems);

    if (index !== undefined && index !== null) {
      onChange(
        {
          target: {
            id: "Body",
            value: updatedItems,
          },
        },
        index,
      );
    } else {
      setFormData({ ...formData, Body: updatedItems });
    }
  };

  const removeItem = (arr, id) => {
    let array = [];
    for (let i = 0; i < arr.length; i++) {
      if (i !== id) {
        array.push(arr[i]);
      }
    }
    handleBodyItemsChange(array);
  };

  return (
    <div
      className="accordion shadow border-0 mt-3"
      id={`body-${index ?? "main"}`}
    >
      <div className="accordion-item border-0">
        <h2 className="accordion-header" id="headingTwo">
          <button
            className="accordion-button focus-primary"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapseTwo-${index ?? "main"}`}
            aria-expanded="false"
            aria-controls={`collapseTwo-${index ?? "main"}`}
          >
            {selectedProbeIds?.length > 0
              ? `Probe ${selectedProbeIds[index]}`
              : `Body ${index !== undefined && index !== null ? index + 1 : ""}`}
          </button>
        </h2>
        <div
          id={`collapseTwo-${index ?? "main"}`}
          className="accordion-collapse collapse show"
          aria-labelledby="headingTwo"
          data-bs-parent={`#body-${index ?? "main"}`}
        >
          <div className="accordion-body">
            {CategoryID <= 4 && (
              <>
                <textarea
                  className="form-control border-primary"
                  rows="5"
                  required
                  placeholder={
                    CategoryID === 3
                      ? "Please add the text"
                      : CategoryID === 4
                        ? "Please add the Words comma separated i.e. AOL,TEK,REL"
                        : CategoryID <= 2
                          ? "Please add the letters comma separated i.e. A,B,C"
                          : ""
                  }
                  value={
                    mode === "edit"
                      ? String(formData.Body || "")
                          .split("&nbsp;")
                          .join(" ")
                      : CategoryID === 3
                        ? formData.body || ""
                        : String(formData.Body || formData.body || "")
                            .split("&nbsp;")
                            .join(" ")
                  }
                  id="Body"
                  onChange={(e) => onChange(e)}
                ></textarea>
                {formData.CategoryID === 3 && (
                  <div>Word Count: {formData?.bodyCount} </div>
                )}
              </>
            )}
            {(CategoryID === 5 || CategoryID === 6) && (
              <div className="">
                {bodyItems.map((item, id) => {
                  return (
                    <div className="d-flex mb-3" key={id}>
                      <div className="d-flex w-80 justify-content-around align-items-end">
                        <div className="w-20">
                          <label htmlFor="Word" className="w-100 text-truncate">
                            Word
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Word"
                            value={item.Word}
                            required
                            placeholder="Please enter a word..."
                            onChange={(e) => {
                              const updated = [
                                ...bodyItems.slice(0, id),
                                { ...bodyItems[id], Word: e.target.value },
                                ...bodyItems.slice(id + 1),
                              ];
                              handleBodyItemsChange(updated);
                            }}
                            onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();
                              const updated = [
                                ...bodyItems.slice(0, id),
                                { ...bodyItems[id], Solution: trimmedValue },
                                ...bodyItems.slice(id + 1),
                              ];
                              handleBodyItemsChange(updated);
                            }}
                          />
                        </div>
                        <div className="w-20">
                          <label htmlFor="Solution">
                            {CategoryID === 6
                              ? "Correct / 2 points"
                              : "Solution"}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Solution"
                            value={item.Solution}
                            required
                            placeholder="Please enter the solution..."
                            onChange={(e) => {
                              const updated = [
                                ...bodyItems.slice(0, id),
                                { ...bodyItems[id], Solution: e.target.value },
                                ...bodyItems.slice(id + 1),
                              ];
                              handleBodyItemsChange(updated);
                            }}
                            onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();
                              const updated = [
                                ...bodyItems.slice(0, id),
                                { ...bodyItems[id], Solution: trimmedValue },
                                ...bodyItems.slice(id + 1),
                              ];
                              handleBodyItemsChange(updated);
                            }}
                          />
                        </div>
                        {CategoryID === 6 && (
                          <div className="w-20">
                            <label
                              htmlFor="SolutionDetails"
                              className="w-100 text-truncate"
                            >
                              Correct / 1 point
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="SolutionDetails"
                              value={item.SolutionDetails}
                              required
                              placeholder="Please enter the solution..."
                              onChange={(e) => {
                                const updated = [
                                  ...bodyItems.slice(0, id),
                                  {
                                    ...bodyItems[id],
                                    SolutionDetails: e.target.value,
                                  },
                                  ...bodyItems.slice(id + 1),
                                ];
                                handleBodyItemsChange(updated);
                              }}
                              onBlur={(e) => {
                                const trimmedValue = e.target.value.trim();
                                const updated = [
                                  ...bodyItems.slice(0, id),
                                  {
                                    ...bodyItems[id],
                                    SolutionDetails: trimmedValue,
                                  },
                                  ...bodyItems.slice(id + 1),
                                ];
                                handleBodyItemsChange(updated);
                              }}
                            />
                          </div>
                        )}
                        <div className="w-20">
                          <label htmlFor="Scores">Score</label>
                          <input
                            type="number"
                            className="form-control"
                            id="Scores"
                            value={CategoryID === 6 ? 2 : item.Scores}
                            disabled={CategoryID === 6}
                            required
                            placeholder="Please enter the Scores..."
                            onChange={(e) => {
                              const updated = [
                                ...bodyItems.slice(0, id),
                                { ...bodyItems[id], Scores: e.target.value },
                                ...bodyItems.slice(id + 1),
                              ];
                              handleBodyItemsChange(updated);
                            }}
                          />
                        </div>
                      </div>
                      {id === bodyItems.length - 1 && (
                        <div
                          className="align-self-end"
                          onClick={() => {
                            const updated = [
                              ...bodyItems,
                              {
                                Word: "",
                                Solution: "",
                                SolutionDetails: "",
                                Scores: "",
                              },
                            ];
                            handleBodyItemsChange(updated);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="37.6"
                            height="37.6"
                            fill="currentColor"
                            className="bi bi-plus add-item-btn rounded-circle border border-primary txt-primary border-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                          </svg>
                        </div>
                      )}
                      {bodyItems.length > 1 && (
                        <div
                          className={`align-self-end ${
                            id === bodyItems.length - 1 ? "mx-2" : ""
                          }`}
                          onClick={() => removeItem(bodyItems, id)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="37.6"
                            height="37.6"
                            fill="currentColor"
                            className="bi bi-trash delete-item-btn rounded-circle border border-2 p-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path
                              fillRule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {bodyItems.length > 1 && parseInt(CategoryID) > 4 && (
              <div className="d-flex justify-content-end">
                <button
                  className="btn button-primary"
                  onClick={() => {
                    const updated = [
                      {
                        Word: "",
                        Solution: "",
                        SolutionDetails: "",
                        Scores: "",
                      },
                    ];
                    handleBodyItemsChange(updated);
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentFormBody;
